import { acceptHMRUpdate, defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'

// Constants for localStorage keys
const HIDE_EXTENSION_POPUP_KEY = 'hideExtensionInstallPopup'
const SHOW_LATER_KEY = 'extensionInstallPopupShowLaterUntil'
const SHOW_LATER_DURATION_MS = 24 * 60 * 60 * 1000 // 24h

export const useExtensionPopupStore = defineStore('extensionPopup', () => {
  // Use localStorage to persist preferences
  const hideExtensionPopup = useLocalStorage<boolean>(
    HIDE_EXTENSION_POPUP_KEY,
    false
  )
  const showLaterUntil = useLocalStorage<number>(SHOW_LATER_KEY, 0)

  // Computed property to determine if popup should be shown
  const canPromptInstallation = computed(() => {
    if (hideExtensionPopup.value === true) return false
    return Date.now() > showLaterUntil.value
  })

  // Function to mark popup as permanently hidden
  function neverShowAgain() {
    hideExtensionPopup.value = true
  }

  // Function to temporarily hide popup for 24 hours
  function remindLater() {
    showLaterUntil.value = Date.now() + SHOW_LATER_DURATION_MS
  }

  return {
    canPromptInstallation,
    neverShowAgain,
    remindLater,
  }
})

// Enable HMR updates for the store
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useExtensionPopupStore, import.meta.hot)
  )
}
